<anms-spinner *ngIf="loadSpinner"></anms-spinner>
<div class="theme-wrapper" [hidden]="!(validLabsite && isDataLoaded)">
  <div *ngIf="isDataLoaded"><anms-toolbar></anms-toolbar></div><mat-sidenav-container id="mat-sidenav-container-root"
    (backdropClick)="onBackdropClick()"><mat-sidenav #sidenav1 (keydown.escape)="onEscape()" mode="push"><object
        data="assets/images/logo.svg" type="image/svg+xml" height="25">Eurofins
        Logo </object><mat-nav-list><a mat-list-item *ngFor="let item of navigation" (click)="sidenav.close()"
          [routerLink]="[item.link]" routerLinkActive="active">{{item.label | translate}}
        </a></mat-nav-list></mat-sidenav><mat-sidenav #sidenav2 (keydown.escape)="onEscape()" [style.width]="formWidth"
      class="mat-elevation-z10" [position]="'end'" [disableClose]="false" [autoFocus]="false" [mode]="$any(formMode)">
      <div class="app-sidenav-content"><ng-template #dynamic></ng-template></div>
    </mat-sidenav>
    <div class="wrapper">
      <div class="toolbar" [style.position]="'true'" [class.mat-elevation-z4]="true"><mat-toolbar><button
            mat-icon-button class="show-lt-md listIcon" (click)="sidenav.open()"><span class="icon-list"></span></button><object
            data="assets/images/logo.svg" type="image/svg+xml" height="25">Eurofins Logo
          </object><span class="spacer"></span><button mat-button class="nav-button hide-lt-md"
            *ngFor="let item of navigation" [routerLink]="[item.link]" routerLinkActive="active"><span
              style="color: #2B3A67">{{item.label | translate}}</span></button><button mat-stroked-button
            color="primary" class="toolbar-signin-button" *ngIf="!loginDisplay && !appSettingService.hidePasswordResetButton"
            (click)="onLoginClick()">{{ 'TopBarMenu.SignIn' | translate }} </button><button mat-stroked-button
            color="primary" [matMenuTriggerFor]="menu"
            *ngIf="!loginDisplay && appSettingService.hidePasswordResetButton">{{ 'TopBarMenu.SignIn' |
            translate }} </button><mat-menu #menu="matMenu">
            <div class="customMenu"><label><button class="customMenuButton sign-in-button"
                  *ngIf="!loginDisplay && appSettingService.hidePasswordResetButton" (click)="onLoginClick()">{{
                  'TopBarMenu.SignIn' | translate }} </button></label>
            </div>
            <div class="customMenu"><label><button class="customMenuButton"
                  *ngIf="!loginDisplay && appSettingService.hidePasswordResetButton" (click)="onPasswordResetClick()">{{
                  'TopBarMenu.PasswordReset' | translate }}
                </button></label></div>
          </mat-menu><button *ngIf="loginDisplay" mat-button [matMenuTriggerFor]="toolbarUserMenu"
            class="profile-button"><span class="icon-user"></span><span class="profile-text hide-lt-md">{{
              'Profile.ProfileHeader' | translate}}</span></button><mat-menu #toolbarUserMenu="matMenu">
            <div class="ProfileInfo" *ngIf="showAccountDetails">
              <div class="profile-flex-row" (click)="naviagteToProfile()">
                <div mat-card-avatar class="icon-user profileheader-image"></div>
                <div class="profile-flex-col">
                  <mat-label class="wordWrap profile-username" matTooltip="{{userDetails.name}}"
                    matTooltipPosition="above"><b>{{userDetails.name}}</b></mat-label>
                  <mat-label class="wordWrap profile-email" matTooltip="{{userDetails.email}}"
                    matTooltipPosition="above">{{userDetails.email}}</mat-label>
                </div>
              </div>
              <mat-divider></mat-divider><button mat-menu-item *ngFor="let item of profileNavigation"
                [routerLink]="[item.link]"><span>{{item.label |
                  translate}}</span></button><mat-divider></mat-divider><button mat-menu-item
                (click)="onLogoutClick()"><span>{{ 'Profile.SignOut' | translate }}</span></button>
            </div>
          </mat-menu><button mat-raised-button color="primary" *ngIf="!loginDisplay" class="hide-sm hide-xs"
            (click)="onSignUpClick()">{{ 'TopBarMenu.RegisterAsVolunteer' | translate }} </button><ng-select class="language-dropdown"
            [items]="languages" bindLabel="value" bindValue="key" [(ngModel)]="selectedLanguage"
            (change)="onLanguageChange(selectedLanguage)" style="width: 80px;" [clearable]="false"
            [searchable]="false"></ng-select></mat-toolbar></div>
      <div *ngIf="isDataLoaded" class="content"
        [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig?.data?.title">
        <router-outlet #o="outlet"></router-outlet>
      </div>
      <div *ngIf="isDataLoaded"><anms-footer class="footer-divider"></anms-footer></div>
    </div>
    <div><button *ngIf="isFormOnHold" style="float: right;" (click)="onHoldForm()" color="warn"
        class="form-on-hold-icon" [ngStyle]="{'margin-top': formHoldIconStyle}" mat-mini-fab><span
          class="icon-chevron-left"></span></button></div>
  </mat-sidenav-container>
</div>
<div class="theme-wrapper" *ngIf="!(validLabsite || isLandingPageShow)"><anms-global-error
    [errorStatusCode]="errorStatusCode" [isNavigateBackRequired]="false"></anms-global-error></div>
<div *ngIf="isLandingPageShow">
  <div class="toolbar" [style.position]="'true'" [class.mat-elevation-z4]="true"><mat-toolbar><object
        data="assets/images/logo.svg" type="image/svg+xml" height="25">Eurofins
        Logo </object><span class="spacer"></span></mat-toolbar></div><anms-landing-page
    (valueEmitter)="getLabsiteURLConfig($event)"></anms-landing-page>
</div><anms-cookie [isShown]="showCookiePage"></anms-cookie>
